<script setup>
import {onMounted, ref} from "vue";
import router from '@/router/index.js';

const email = ref('');

onMounted(() => {
  email.value = sessionStorage.getItem('forgotPasswordEmail');
  sessionStorage.removeItem('forgotPasswordEmail');

  if(!email.value) {
    sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
    sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
    router.push('/error');
  }
})

const goToLogin = () => {
  router.push('/login');
}
</script>

<template>
  <h2 class="title_sub1">メール送信完了</h2>
  <div class="com_checked_cnt1">
    <img src="/front/assets/common/img/check_fig1.png" alt="" class="check_fig1">
    <p>パスワード再設定メールを送信しました</p>
    <p class="com_fs16">{{ email }}</p>
    <button @click="goToLogin" class="btn com_btn4 cl1 com_strong1 com_mgt10s">ログイン</button>
  </div>
</template>

